import { render, staticRenderFns } from "./dataStatisticsMamSub.vue?vue&type=template&id=8619bb68&scoped=true"
import script from "./dataStatisticsMamSub.vue?vue&type=script&lang=js"
export * from "./dataStatisticsMamSub.vue?vue&type=script&lang=js"
import style0 from "./dataStatisticsMamSub.vue?vue&type=style&index=0&id=8619bb68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8619bb68",
  null
  
)

export default component.exports